import { useLocation, useNavigate } from "react-router-dom";
import { Link as ScrollLink, scroller } from "react-scroll";

type NavItemProps = {
  label: string;
  sectionId: string;
  forceActive?: boolean;
  onActive?: (id: string) => void; // ✅ ADD
};

const NavItem: React.FC<NavItemProps> = ({
  label,
  sectionId,
  forceActive = false,
  onActive,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location.pathname === "/";

  const baseClass =
    "relative text-sm font-medium transition-colors duration-300 px-2 py-1 cursor-pointer " +
    'after:content-[""] after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-full ' +
    "after:origin-left after:scale-x-0 after:bg-accent after:transition-transform after:duration-300";

  const activeClass = "text-primary after:scale-x-100";
  const inactiveClass =
    "text-text-secondary hover:text-primary hover:after:scale-x-100";

  /* HOME PAGE → SCROLL SPY MODE */
  if (isHome) {
    return (
      <ScrollLink
        to={sectionId}
        smooth
        duration={500}
        spy
        offset={-80}
        activeClass={activeClass}
        className={`${baseClass} ${inactiveClass}`}
        onSetActive={(id) => onActive?.(id)} // ✅ ADD
      >
        {label}
      </ScrollLink>
    );
  }

  /* OTHER ROUTES */
  return (
    <span
      onClick={() => {
        navigate("/");
        setTimeout(() => {
          scroller.scrollTo(sectionId, {
            smooth: true,
            duration: 500,
            offset: -80,
          });
        }, 100);
      }}
      className={`${baseClass} ${
        forceActive ? activeClass : inactiveClass
      }`}
    >
      {label}
    </span>
  );
};

export default NavItem;